import React from "react";

export default function Card(props) {
  const { children, footer, header, className, headerClass, childrenClass, footerClass } = props;

  return (
    <div className={`bg-white overflow-hidden border rounded-xl ${className}`}>
    {header && <div className={`px-4 py-5 sm:px-6 ${headerClass}`}>{header}</div>}
    <div className={`px-4 py-5 sm:p-6 ${childrenClass}`}>{children}</div>
    {footer && <div className={`px-4 py-5 sm:px-6 ${footerClass}`}>{footer}</div>}
  </div>
  );
}
